export interface Testimonial {
  initials: string
  quote: string
  name: string
  role: string
  location: string
}
/** Three short quotes used high on the page as fast social proof. */
export const quickTestimonials: Testimonial[] = [
  {
    initials: 'JR',
    quote:
      'Zaplanowałem cały rok nauczania w jeden wieczór. Teraz każda lekcja ma jasny cel, a moi uczniowie nie mogą się doczekać zajęć.',
    name: 'Julian R.',
    role: 'Pedagog jazzowy',
    location: 'Londyn',
  },
  {
    initials: 'MS',
    quote:
      'Nie spędzam już wieczorów na szukaniu ćwiczeń w internecie. Otwieram Arsenał Nauczyciela Jazzu i mam wszystko: uporządkowane, gotowe i profesjonalne. Wart 10 razy więcej niż kosztuje.',
    name: 'Mark S.',
    role: 'Właściciel prywatnego studia',
    location: 'Austin',
  },
  {
    initials: 'ST',
    quote:
      'Moi uczniowie robią postępy 3 razy szybciej, bo wreszcie podążają za logiczną progresją. To zmieniło sposób, w jaki uczę jazzu.',
    name: 'Sophie T.',
    role: 'Dyrektorka szkoły muzycznej',
    location: 'Melbourne',
  },
]
/** Full wall of reviews further down the page. */
export const testimonials: Testimonial[] = [
  {
    initials: 'JR',
    quote:
      'Zaplanowałem cały rok w jeden wieczór. Każda lekcja ma teraz jasny cel. Moi uczniowie nie mogą się doczekać wejścia do studia. To zmieniło wszystko.',
    name: 'Julian R.',
    role: 'Wykładowca jazzu',
    location: 'Londyn',
  },
  {
    initials: 'MS',
    quote:
      'Po dwóch miesiącach moi uczniowie zrobili bardziej widoczne postępy niż przez cały poprzedni rok. Ta progresja naprawdę działa.',
    name: 'Mark S.',
    role: 'Właściciel prywatnego studia',
    location: 'Austin',
  },
  {
    initials: 'ST',
    quote:
      'Wcześniej spędzałam godziny w internecie, szukając pomysłów. Teraz otwieram Arsenał Nauczyciela Jazzu i wszystko tam jest — uporządkowane, gotowe, profesjonalne.',
    name: 'Sophie T.',
    role: 'Dyrektorka szkoły muzycznej',
    location: 'Melbourne',
  },
  {
    initials: 'JF',
    quote:
      'Szablony ocen zmieniły moją komunikację z rodzicami. Teraz mogę pokazać konkretne, mierzalne postępy.',
    name: 'Julia F.',
    role: 'Koordynatorka programu',
    location: 'Toronto',
  },
  {
    initials: 'AS',
    quote:
      'Jako początkująca nauczycielka byłam kompletnie przytłoczona. Ten system dał mi profesjonalną pewność siebie od pierwszego dnia.',
    name: 'Anna S.',
    role: 'Pedagożka jazzowa',
    location: 'Sydney',
  },
]
